import { c as _c } from "react/compiler-runtime";
import { Box, Separator, HStack, Icon, Text, VStack, Badge } from '@chakra-ui/react';
import { Wrap } from '@chakra-ui/react';
import { Avatar, Stack } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { BiSolidQuoteLeft } from 'react-icons/bi';
import { TbTargetArrow } from 'react-icons/tb';
export interface FeaturedMemberCardProps {
  name?: string;
  title?: string;
  tags?: string[];
  category?: string;
  pictureUrl?: string;
  quote?: string;
  whyItMatters?: string;
}
const FeaturedMemberCard = t0 => {
  const $ = _c(34);
  const {
    name,
    title,
    tags,
    category,
    pictureUrl,
    quote,
    whyItMatters
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Avatar.Fallback />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== pictureUrl) {
    t2 = <Avatar.Root size="md">{t1}<Avatar.Image src={pictureUrl} /></Avatar.Root>;
    $[1] = pictureUrl;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name) {
    t3 = <Text color="colorPalette.text" fontWeight="semibold" textStyle="md">{name}</Text>;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== category) {
    t4 = <Text color="colorPalette.fg/50" fontWeight="medium" textStyle="sm">{category}</Text>;
    $[5] = category;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <VStack align="flex-start" gap={0}>{t3}{t4}</VStack>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <Stack align="center" direction="row" gap={2} paddingBottom={0} width="full">{t2}{t5}</Stack>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== title) {
    t7 = <Flex align="flex-start" justify="flex-start" width="full"><Text color="colorPalette.text" fontWeight="medium" textStyle="sm">{title}</Text></Flex>;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== quote) {
    t8 = quote && <Box bgColor="purpleLightAlpha.100" borderRadius="lg" padding={4} width="full"><Flex justify="flex-start" marginBottom={2} width="full"><Icon asChild={true} boxSize={4} color="colorPalette.border"><BiSolidQuoteLeft /></Icon></Flex><Text color="colorPalette.border" opacity={1}>{quote}</Text></Box>;
    $[15] = quote;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== whyItMatters) {
    t9 = whyItMatters && <HStack align="flex-start" bgColor="Purple50" borderRadius="lg" gap={2} justify="flex-start" padding={4} width="full"><Icon asChild={true} boxSize={6} color="colorPalette.border"><TbTargetArrow /></Icon><Text color="colorPalette.border" opacity={1} textStyle="labelSm">{whyItMatters}</Text></HStack>;
    $[17] = whyItMatters;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <VStack align="flex-start" gap={2} justify="flex-start" width="full">{t8}{t9}</VStack>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <HStack align="center" gap={2} justify="flex-start" width="full"><Badge color="colorPalette.border" opacity={1} variant="label">Skills</Badge><Separator flex={1} /></HStack>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== tags) {
    t12 = tags.map(_temp);
    $[23] = tags;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <VStack align="flex-start" gap={2} justify="flex-start" width="full">{t11}<Wrap>{t12}</Wrap></VStack>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t7) {
    t14 = <Stack align="flex-start" gap={2} justify="space-between" width="full">{t7}{t10}{t13}</Stack>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t7;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t6) {
    t15 = <VStack align="flex-start" bgColor="colorPalette.card/50" borderRadius="2xl" boxShadow="sm" gap={4} justify="flex-start" padding={6} width="full">{t6}{t14}</VStack>;
    $[31] = t14;
    $[32] = t6;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
export default FeaturedMemberCard;
function _temp(tag, index) {
  return <Badge key={index} bgColor="colorPalette.fg/10">{tag}</Badge>;
}